/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export class FileExplorerOptions {
  /**
   * Indicate if fileExplorer show his title
   */
  public showTitle = true;
  /**
   * Title of fileExplorer
   */
  public title: string[];
  /**
   * Indicate if fileExplorer show search input inside columns
   */
  public showSearch = false;
  /**
   * key used to store user settings of this component
   */
  public storageKey?: string;
  /**
   * Allowing Drag and Drop file inside columns
   */
  public allowDragNDrop = false;
  /**
   * Is the fileExplorer reflects columns content choices into a breadcrumb
   */
  public displayColumnToBreadCrumb = false;
  /**
   * Indicate if all columns have same size
   */
  public fixedColumnWidth = false;
}
